import { IonCol, IonRow, useIonToast } from '@ionic/react';
import React from 'react';
import styled from 'styled-components';
import ProfilePictureForm from './ProfilePictureForm';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import { useFirebase } from '../../../services/firebase';
import { updateProfile } from 'firebase/auth';
import { setUserMetadata } from '../../../services/firebase/user';
import { getDatabase } from 'firebase/database';
import { uploadProfilePicture } from '../../../services/firebase/storage';
import { checkmarkCircle, warning } from 'ionicons/icons';

interface ProfilePictureProps {
  photoURL: string;
}
const FlexCol = styled(IonCol)`
  display: flex;
  justify-content: center;
`;
const ProfilePictureWrapper = styled.div`
  margin-bottom: 16px;
`;

const ProfilePicture: React.FC<ProfilePictureProps> = ({ photoURL }) => {
  const { app, currentUser } = useFirebase();
  const [present] = useIonToast();
  return (
    <IonRow>
      <FlexCol>
        <ProfilePictureWrapper>
          <ProfilePictureForm
            photoURL={photoURL}
            onSubmit={async ({ photoFile }) => {
              try {
                const storage = getStorage(app);
                const profileImage = await uploadProfilePicture(
                  storage,
                  photoFile!,
                  currentUser!.uid
                );
                const fileRef = ref(
                  storage,
                  `profile_pictures/${currentUser!.uid}/${profileImage}`
                );
                const photoUrl = await getDownloadURL(fileRef);

                await updateProfile(currentUser!, {
                  photoURL: photoUrl,
                });

                await setUserMetadata(getDatabase(app), currentUser!, {
                  photoUrl: photoUrl || currentUser?.photoURL || '',
                });
                present({
                  message: 'Profile picture updated successfully',
                  duration: 2000,
                  icon: checkmarkCircle,
                });
              } catch (e) {
                console.error(e);
                present({
                  message: 'Error uploading profile picture',
                  duration: 2000,
                  color: 'danger',
                  icon: warning,
                });
              }
            }}
          />
        </ProfilePictureWrapper>
      </FlexCol>
    </IonRow>
  );
};

export default ProfilePicture;
